// ═══════════════════════════════════════════════════════════════════════════════
// Pending invitation-code deep link (/invite-code/:code → register)
// ═══════════════════════════════════════════════════════════════════════════════

const STORAGE_KEY = 'fdh.pendingInviteCode';

export type PendingInviteCode = {
  code: string;
  /** When true, register form must not allow editing the code. */
  locked: boolean;
  /** Landing page found the code invalid / expired / maxed. */
  showInvalidHint: boolean;
};

export const writePendingInviteCode = (payload: PendingInviteCode): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
};

export const readPendingInviteCode = (): PendingInviteCode | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as PendingInviteCode;
    if (typeof parsed.code !== 'string') {
      return null;
    }
    return {
      code: parsed.code.trim().toUpperCase(),
      locked: parsed.locked === true,
      showInvalidHint: parsed.showInvalidHint === true,
    };
  } catch {
    return null;
  }
};

export const clearPendingInviteCode = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
